import { translateLang } from '@/data/i18n/translateLang'

// 余料表头
export const surplusHeaders = [
  { label: '余料名称', props: 'name', width: '4', unit: '' },
  { label: '余料条码', props: 'plankNum', width: '6', unit: '' },
  { label: '形状', props: 'shape', width: '3', unit: '' },
  { label: '类型', props: 'type', width: '4', unit: '' },
  { label: '颜色', props: 'color', width: '4', unit: '' },
  { label: '厚度', props: 'thick', width: '4', unit: 'mm' },
  { label: '长度', props: 'long', width: '4', unit: 'mm' },
  {
    label: '短边长度',
    props: 'min_long',
    width: '4',
    unit: 'mm',
  },
  { label: '宽度', props: 'width', width: '5', unit: 'mm' },
  {
    label: '短边宽度',
    props: 'min_width',
    width: '5',
    unit: 'mm',
  },
  {
    label: '修边',
    props: 'surplus_trim_edge',
    width: '5',
    unit: '',
  },
  {
    label: '高光板',
    props: 'is_high_gloss_plank',
    width: '6',
    unit: '',
  },
  { label: '添加时间', props: 'create_time', width: '5', unit: '' },
  { label: '所在余料库', props: 'branch_name', width: '5', unit: '' },
  { label: '来源订单地址', props: 'from_address', width: '6', unit: '' },
  { label: '来源订单号', props: 'from_order_num', width: '6', unit: '' },
  { label: '备注', props: 'remark', width: '6', unit: '' },
  { label: '面积', props: 'area', width: '5', unit: 'm²' },
  { label: '数量', props: 'showAmount', width: '4', unit: '' },
  { label: '操作', props: 'operation', width: '5', unit: '' },
] as const

// 表头映射表
export const tableHeaderMappingList = {
  [translateLang('板号')]: 'plankID',
  [translateLang('材质')]: 'matCode',
  [translateLang('颜色')]: 'texture',
  [translateLang('板件名称')]: 'partName',
  [translateLang('板材长度')]: 'specHeight',
  [translateLang('板材宽度')]: 'specWidth',
  [translateLang('数量')]: 'amount',
  [translateLang('面积')]: 'area',
  [translateLang('左封边')]: 'leftEdge',
  [translateLang('右封边')]: 'rightEdge',
  [translateLang('前封边')]: 'frontEdge',
  [translateLang('后封边')]: 'backEdge',
  [translateLang('纹理')]: 'texDir',
  [translateLang('厚度')]: 'thick',
  [translateLang('项目地址')]: 'address',
  [translateLang('板件条码')]: 'oriPlankNum',
  [translateLang('客户')]: 'customer_name',
  [translateLang('房间')]: 'roomName',
  [translateLang('订单号')]: 'orderNo',
  [translateLang('柜体')]: 'loc',
  [translateLang('孔槽数量')]: 'hsInfo',
  [translateLang('异形')]: 'specialShape',
  [translateLang('门板')]: 'type',
  [translateLang('板件备注')]: 'plank_remarks',
  [translateLang('房间备注')]: 'remark',
  [translateLang('高光板')]: 'is_high_gloss_plank',
  [translateLang('开门方向')]: 'openDir',
  // 好像暂时没用到
  [translateLang('订单备注')]: 'order_remark',
}

// 高光板下拉框配置项
export const highPlankOptions = [
  { value: true, label: '高光板' },
  { value: false, label: '非高光' },
]

// 纹理配置项
export const texDirOptions = [
  { value: 'reverse', label: '横纹' },
  { value: 'normal', label: '竖纹' },
  { value: 'notcare', label: '无纹理' },
]

// 门板配置项
export const doorOptions = [
  { value: 'Plank', label: '非门板' },
  { value: 'SingleDoor', label: '门板' },
]
